import { ICategory } from '../category/category.model';
import { ILocation } from '../location/location.model';
import { IUserDetails } from '../user-details/user-details.model';
import { IVehicleDetails } from '../vehicle/vehicle.model';

export interface IReportAction {
  categoryId: string;
  category: ICategory;
  completed: boolean;
  completedAt: string;
  description: string;
  groupId: string;
  id: string;
  organisationId: string;
  reportPeriodId: string;
  title: string;
  userId: string;
  relatedObjectId: string;
  relatedModelName: string;
  actionBillingPeriod: string;
  actionPeriod: string;
  actionYear: string;
  vehicle: IVehicleDetails | null;
  user: IUserDetails;
  location: ILocation | null;
  emissionIds?: string[];
  // Headline CO2e (kg) reported by this action's entries; null when nothing reported yet.
  readonly reportedKgCo2e?: number | null;
  startDate: string;
  endDate: string;
  readonly actionCode: ActionCode
  readonly dataDetected?: boolean,
  // Workflow status beyond completed: null/undefined is normal open work. blocked and
  // waiting_external keep the action outstanding but flagged back to the admins;
  // not_applicable records a business fact and removes it from outstanding work.
  status?: ActionStatus | null,
  statusReason?: string | null,
  // Provenance for tasks created from readiness findings.
  readonly sourceCheckId?: string | null,
  readonly deepLink?: string | null,
}

export type ActionStatus = 'blocked' | 'waiting_external' | 'not_applicable'

export interface IReportAndReductionAction {
  id: string;
  type: string;
  title: string;
  date: string;
  startDate: string;
  endDate: string;
  userId: IUserDetails;
  groupId: string;
  completed: boolean;
  actionPeriod: string;
  actionBillingPeriod: string;
  actionYear: string;
  user: IUserDetails;
}

export enum ActionCode {
  Vehicle = 'vehicle',
  LocationElectricity = 'location_electricity',
  LocationGas = 'location_gas',
  LocationSteam = 'location_steam',
  LocationAircon = 'location_aircon',
  LocationWater = 'location_water',
  LocationWaste = 'location_waste',
  LocationUtilities = 'utilities'
}
